// extracted by mini-css-extract-plugin
export default {"list_result":"FindId_list_result__XmhQt","name":"FindId_name__pd7CX","detail":"FindId_detail__bMVt8"};